import './app.js'
import ContactStep from './contactstep.js'
import ArticleAbstract from './article-abstract.js'
import CamperAbstract from './camper-abstract.js'
import CamperForm from './camper-form.js'
import FacebookShare from './facebook-share.js'
import PhotoSphereBtn from './photosphere-button.js'
import { loadScript } from './helpers.js'

//Camper Form
CamperForm.init()

//face book share button init
FacebookShare.init()

//photospehere init
PhotoSphereBtn.init()

//contact
ContactStep.create('#contact-form', true)

//init abstracts ( Related )
CamperAbstract.init()
ArticleAbstract.init()

//gallery delayed load
setTimeout(() => {
    //common scripts
    loadScript('/js/camper-delayed.js')
}, process.env.MIX_LIB_3RD_DELAY)
